import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 5rem;

  overflow: auto;

  body {
    overflow: scroll;
  }

  .purple-radio {
    width: 18px;
    height: 18px;
    background-color: red;
    accent-color: ${({ theme }) => theme.colors.background};
    margin-right: 1rem;
    font-size: 1.6rem;

    @media (max-width: 1366px) {
      width: 13px;
      height: 13px;
    }
  }
`;

export const Full = styled.div`
  /* min-height: 1000px; */
  overflow: hidden !important;
`;

export const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
`;

export const Header = styled.div`
  width: 100%;
  height: 95px;
  display: flex;
`;

export const NavLeft = styled.div`
  width: 10%;
  min-width: 297px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    background-color: transparent;
    cursor: pointer;
    margin-top: 1.7rem;
  }

  .logo-uxdoc-account {
    width: 160px;
  }

  @media (max-width: 1366px) {
    min-width: 210px;

    .logo-uxdoc-account {
      width: 120px;
    }
  }
`;

export const Text = styled.span`
  font-size: 2rem;
  font-family: "Roboto", sans-serif;
  color: #a5a5a5;
  margin-top: 4rem;
  margin-bottom: 1rem;

  @media (max-width: 1366px) {
    font-size: 1.6rem;
    margin-top: 3rem;
  }
`;

export const NavRest = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
`;

export const Line = styled.div<{ margin?: string }>`
  border: 2px solid #eaeaea;
  transform: translateY(-5px);
  margin: ${({ margin }) => margin && margin};
`;

export const Heading = styled.h3`
  font-size: 2.4rem;
  font-weight: 500;
  margin-top: 3rem;

  @media (max-width: 1366px) {
    font-size: 2rem;
  }
`;

export const VStack = styled.div`
  width: 100%;
  height: 160px;
  display: flex;
  padding: 2rem 0;
  align-items: center;
  margin-top: 1rem;
`;

export const LeftInfo = styled.div`
  width: 150px;

  /* background: yellow; */
  display: flex;
  align-items: center;
`;

export const MiddleInfo = styled.div`
  width: 50%;

  /* background: red; */
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1366px) {
    width: 40%;
    margin-left: -3rem;
    margin-right: 3rem;
  }
`;

export const ButtonUploadInfo = styled.div`
  width: 50%;

  /* background: blue; */
  display: flex;
  align-items: center;

  @media (max-width: 1366px) {
    width: 40%;
  }
`;

export const AvatarEditProfile = styled.div<{ src?: string }>`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-image: ${({ src }) => `url(${src})`};
  background-size: cover;
  background-position: center;

  @media (max-width: 1366px) {
    width: 80px;
    height: 80px;
  }
`;

export const DescriptionHead = styled.h4`
  font-size: 2rem;
  font-weight: 500;
  color: #555454;
  margin-bottom: 0.25rem;

  @media (max-width: 1366px) {
    font-size: 1.8rem;
  }
`;

export const DescriptionText = styled.span`
  font-size: 1.8rem;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  margin-top: 0.25rem;

  @media (max-width: 1366px) {
    font-size: 1.6rem;
    margin-right: 1rem;
    margin-top: 0.7rem;
  }
`;

export const ButtonUpload = styled.button`
  width: 21.4rem;
  height: 5rem;
  background: black;
  color: white;
  font-size: 2rem;
  border-radius: 1rem;
  transition: all 120ms linear;

  :hover {
    background: ${({ theme }) => theme.colors.background};
  }

  @media (max-width: 1366px) {
    width: 18rem;
    font-size: 1.6rem;
  }
`;

export const InputBox = styled.div`
  width: 66%;
  height: 50px;
  margin-top: 1rem;
  display: flex;
`;

export const LabelWrapper = styled.div`
  width: 150px;
  display: flex;

  select {
    border: none;
    font-family: "Roboto", sans-serif;
    font-size: 1.8rem;
    color: #555454;
    margin-left: -0.3rem;
    margin-top: 0.4rem;
  }

  @media (max-width: 1366px) {
    width: 120px;
  }
`;

export const InputWrapper = styled.input`
  border: 1px solid #a5a5a5;
  display: flex;
  flex: 1;
  height: 50px;
  padding: 2rem;
  font-size: 1.6rem;

  @media (max-width: 1366px) {
    font-size: 1.4rem;
    height: 45px;
  }
`;

export const LabelInput = styled.span`
  font-size: 2rem;
  color: #555454;
  font-family: "Roboto", sans-serif;
  font-weight: normal;
  margin-top: 0.5rem;

  @media (max-width: 1366px) {
    font-size: 1.6rem;
  }
`;

export const ButtonSave = styled.button`
  width: 214px;
  height: 50px;
  font-size: 2rem;
  background-color: black;
  color: white;
  border-radius: 1rem;
  margin-top: 3rem;
  transition: all 120ms linear;

  :hover {
    background: ${({ theme }) => theme.colors.background};
  }

  @media (max-width: 1366px) {
    width: 200px;
    height: 42px;
    font-size: 1.6rem;
    margin-top: 2rem;
  }
`;

export const ButtonEdits = styled.button<{ color?: string; margin?: string }>`
  height: 30px;

  background-color: white;
  color: ${({ color, theme }) => (color ? color : theme.colors.background)};
  display: flex;
  font-size: 2rem;
  margin: ${({ margin }) => margin && margin};

  @media (max-width: 1366px) {
    font-size: 1.6rem;
    height: 25px;
  }
`;

export const VerticalStack = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;
`;

export const HorizontalStack = styled.div`
  display: flex;
  margin-top: 0.75rem;
  span {
    font-size: 2rem;
    color: #343a40;
    margin-left: 1rem;
    transform: translateY(-2.5px);
  }

  @media (max-width: 1366px) {
    span {
      font-size: 1.6rem;
    }
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 45px;
  font-size: 1.8rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
  border: none;
  border-bottom: 1px solid #555454;

  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),
    inset 0 0 0 100px rgba(255, 255, 255, 1);

  @media (max-width: 1600px) {
    font-size: 1.6rem;
    height: 30px;
  }

  @media (max-width: 1366px) {
    height: 38px;
    font-size: 1.4rem;
    height: 30px;
    margin-top: 1.5rem;
  }

  @media (max-width: 800px) {
    margin-top: 0rem;
  }
`;
